export default __webpack_public_path__ + "static/media/pending-image.b46a9f2a.svg";